import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createVNode as _createVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/home/studio-mobile.jpg'


const _hoisted_1 = { class: "header-video" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "core-advantages" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "core-scene" }
const _hoisted_6 = { class: "studio-video" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "cost-box" }
const _hoisted_9 = {
  style: {"background-color":"#fff"},
  class: "cost-base"
}
const _hoisted_10 = { class: "cost-wrap" }
const _hoisted_11 = { class: "easy-operate" }
const _hoisted_12 = { class: "easy-operate-image" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "arrange" }
const _hoisted_15 = { class: "arrange-icon" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "fusion" }
const _hoisted_18 = {
  key: 0,
  class: "fusion-bg"
}
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "fusion-window" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "fusion-list-info" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "metaverse-title" }
const _hoisted_25 = { class: "metaverse-content" }
const _hoisted_26 = { class: "show-project" }
const _hoisted_27 = { class: "partner-wrap" }
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "partner-list partner5" }
const _hoisted_30 = ["src"]

import { ref, reactive, onMounted, watch, onUnmounted } from 'vue'
import BannerView from '@/components/BannerView.vue';
import ContactUs from '@/components/ContactUs2.vue'
import GlobalCustomerService from '@/components/GlobalCustomerService.vue'
import { useStore } from 'vuex'
import { addConsult } from '@/api'
import { asynchronousRetrieval } from '@/utils'


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const loadUrl: any = ref({})
const costList = [['降低', '50%', '技术开发成本'], ['增加', '200%', '投资回报率'], ['节省', '80%', '部署时间'], ['综合提效', '300%', '创作落地']]
const arrangeList = [require('@/assets/images/home/list-icon.png'), require('@/assets/images/home/audio-bg-icon.png'), require('@/assets/images/home/service-bg-icon.png'), require('@/assets/images/home/blank-bg-icon.png'), require('@/assets/images/home/data-bg-icon.png'), require('@/assets/images/home/wifi-bg-icon.png'), require('@/assets/images/home/phone-bg-icon.png')]
const metaversePlatformList: any = ref(
  [
    {
      title: '文娱元宇宙',
      type: 1,
      content: '景区导览、遗迹重现、虚拟博物馆/文化馆/艺术馆、商业空间、IP展览、儿童游乐项目体验、企业展厅、营销互动、大型活动、虚拟数字人',
    },
    {
      title: '工业元宇宙',
      type: 2,
      content: '远程协助、数字孪生、点巡检、虚拟装配、维修维护、工厂漫游、技能培训、设计评审',
    },
    {
      title: '教育元宇宙',
      type: 3,
      content: '基础教育/高等教育/职业教育教学、播控、创新实验室建设、创新课堂建设、企业培训',
    }
  ]
)
const projectTypeList: any = ref(
  [
    {
      title: '微信小程序',
      type: 0,
      content: '高效创作XR/3D/数字人/虚拟展厅等元宇宙内容助力品牌/营销',
      frameNum: 198,
      key: 'wechat',
      diff: 7,
      imgs: [
        {
          url: loadUrl.value.wechat_gif,
          class: 'wechat-bg',
          size: [-356, -321]
        },
        {
          url: require('@/assets/images/home/wechat-icon.png'),
          class: 'wechat-icon',
          size: [-200, -202]
        },
        {
          url: require('@/assets/images/home/wechat-icon2.png'),
          class: 'wechat-icon2',
          size: [-60, 190]
        }
      ]
    },
    {
      title: 'VR端',
      type: 1,
      content: '高效创作XR/3D/数字人/虚拟展厅等元宇宙内容助力品牌/营销',
      frameNum: 108,
      key: 'VR',
      diff: 67,
      imgs: [
        {
          url: loadUrl.value.VR_gif,
          class: 'room-bg',
          size: [-356, -321]
        },
        {
          url: require('@/assets/images/home/rokid.png'),
          class: 'rokid',
          size: [-250, 50]
        }
      ]
    },
    {
      title: 'AR端',
      type: 2,
      content: '高效创作XR/3D/数字人/虚拟展厅等元宇宙内容助力品牌/营销',
      frameNum: 108,
      key: 'AR',
      diff: 0,
      imgs: [
        {
          url: loadUrl.value.AR_gif,
          class: 'ar-bg',
          size: [-356, -321]
        },
        {
          url: require('@/assets/images/home/ar-rokid.png'),
          class: 'ar-rokid',
          size: [-288, 8]
        }
      ]
    },
    {
      title: 'web端',
      type: 3,
      content: '高效创作XR/3D/数字人/虚拟展厅等元宇宙内容助力品牌/营销',
      frameNum: 108,
      key: 'web',
      diff: 5,
      imgs: [
        {
          url: loadUrl.value.web_gif,
          class: 'web-gif',
          size: [-350, -250]
        },
      ]
    },
  ]
)
const activeFusionIndex = ref(0)
const showCustomerState = ref(0)
const store = useStore()
const viewTime = ref(0)
let timer: any = null;
const contactInfo: any = reactive({
  companyName: '',
  name: '',
  phone: '',
  industry: null
})
const industryList = [
  {
    name: '文娱',
    value: 1,
  },
  {
    name: '工业',
    value: 2,
  },
  {
    name: '教育',
    value: 3,
  },
  {
    name: '其他',
    value: 4,
  }
]
const fusionVideo: any = ref([20.966667, 18.552993, 16.068005])
const showError = ref(false)
const checkEmpty: any = ref({})


const handleEvent = () => {
  let contactUsTop: any = store.state.contactUsTop;
  contactUsTop = {
    bottom: 628 + 'rem'
  }
  store.state.contactUsTop = JSON.parse(JSON.stringify(contactUsTop))
}

const submitEvent = () => {
  let reg = /^(130|131|132|133|134|135|136|137|138|139|145|146|147|148|149|150|151|152|153|155|156|157|158|159|166|170|171|173|174|175|176|177|178|180|181|182|183|184|185|186|187|188|189|191|198|199)\d{8}$/
  Object.keys(contactInfo).forEach((k) => {
    checkEmpty.value[k] = !contactInfo[k]
  })
  if (!reg.test(contactInfo.phone.replace(/\s+/g, "")) || !contactInfo.phone) {
    showError.value = true;
    return
  } else if (!contactInfo.companyName || !contactInfo.name || !contactInfo.industry) {
    return
  }
  addConsult({ ...contactInfo }).then((res: any) => {
    showCustomerState.value = 2;
    contactInfo.companyName = ''
    contactInfo.name = ''
    contactInfo.phone = ''
    contactInfo.industry = null
    showError.value = false;
    checkEmpty.value = {}
  })
}

const changeState = (val: number) => {
  showCustomerState.value = val;
}

const scrollEvent = () => {
  // 执行的具体操作
  let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  (document.querySelector('.header') as any).style.transition = 'all 1s'
  const screenRatio = (window.innerWidth / 1920);


  // 虚实融合
  const fusionTop: any = (document.querySelector('.fusion') as any).getBoundingClientRect().top;
  const videoMask: any = document.querySelector('.video-mask');
  if (fusionTop <= 100 * screenRatio && !store.state.zoomScreened) {
    store.state.zoomScreened = true;
    const fusionWindow: any = document.querySelector('.fusion-window');
    if (fusionWindow) {
      fusionWindow.style.scale = 1;
      fusionWindow.style.opacity = 1;
      openTimer()
    }
  } else if (fusionTop > 100 * screenRatio) {
    openTimer()
  }

  if (scrollTop > 30) {
    videoMask.style.height = '50%';
  } else {
    videoMask.style.height = 0;
  }

  // 部署模块动效
  const arrangeChild: any = document.querySelectorAll('.arrange-icon>div');
  const arrangeTop: any = (document.querySelector('.arrange-icon') as any).getBoundingClientRect().top;
  if (arrangeTop > 0 && arrangeTop < window.innerHeight) {
    const offsetValue = (40 * screenRatio) * (arrangeTop / window.innerHeight);
    arrangeChild.forEach((ele: any, i: number) => {
      if (i < 3) {
        ele.style.left = offsetValue + 'px'
      } else {
        ele.style.right = offsetValue + 'px'
      }
    })
  }

  // 服务客户动效
  const partnerList: any = document.querySelectorAll('.partner-list:not(.partner5)');
  const partnerItem = (document.querySelector('.partner-wrap') as any).getBoundingClientRect();
  const partnerTop: any = partnerItem.top;
  if ((partnerTop > 0 && partnerTop < window.innerHeight) || partnerTop > -(partnerItem.height)) {
    const offsetValue = (100 * screenRatio) * (partnerTop / window.innerHeight);
    partnerList.forEach((ele: any, i: number) => {
      if (i % 2) {
        ele.style.marginLeft = -offsetValue + 'px'
      } else {
        ele.style.marginLeft = offsetValue + 'px'
      }
    })
  }

  // 成本模块动效
  const costBase: any = document.querySelector('.cost-base');
  const costBaseTop: any = costBase.getBoundingClientRect().top;
  if (costBaseTop > window.innerHeight) {
    costBase.style.top = '60rem'
  } else {
    costBase.style.top = Math.max(60 - (window.innerHeight - costBaseTop), 0) + 'rem'
  }

  // 高精度
  const highPrecision: any = document.querySelector('.high-precision');
  const highPrecisionTop: any = highPrecision.getBoundingClientRect().top;
  if (highPrecisionTop < window.innerHeight - 300) {
    (document.querySelector('.high-precision-image') as any).style.left = '31rem'
  }
  if (highPrecisionTop > window.innerHeight) {
    highPrecision.style.top = '80rem'
  } else {
    highPrecision.style.top = Math.max(80 - (window.innerHeight - highPrecisionTop), 0) + 'rem'
  }

  // 易操作
  const easyOperate: any = document.querySelector('.easy-operate');
  const easyOperateTop: any = easyOperate.getBoundingClientRect().top;
  if (easyOperateTop < window.innerHeight - 500) {
    (document.querySelector('.easy-operate-image') as any).style.left = '84rem'
  }

  if (easyOperateTop > window.innerHeight) {
    easyOperate.style.top = '80rem'
  } else {
    easyOperate.style.top = Math.max(80 - (window.innerHeight - easyOperateTop), 0) + 'rem'
  }

  // 部署模块动效
  const arrange: any = document.querySelector('.arrange');
  const arrangeTops: any = arrange.getBoundingClientRect().top;
  if (arrangeTops > window.innerHeight) {
    arrange.style.top = '60rem'
  } else {
    arrange.style.top = Math.max(60 - (window.innerHeight - arrangeTops), 0) + 'rem'
  }

  // 部署模块动效
  const studioVideo: any = document.querySelector('.studio-video');
  const studioVideoTops: any = studioVideo.getBoundingClientRect().top;
  if (studioVideoTops > window.innerHeight) {
    studioVideo.style.top = '60rem'
  } else {
    studioVideo.style.top = Math.max(60 - (window.innerHeight - studioVideoTops), 0) + 'rem'
  }

  // 成本模块动效
  const costChild: any = document.querySelectorAll('.cost-wrap>div>div');
  const costTop: any = (document.querySelector('.cost-wrap') as any).getBoundingClientRect().top;
  costChild.forEach((ele: any, i: number) => {
    if (costTop < (window.innerHeight - (i + 1) * 100)) {
      ele.style.left = 0
    } else if (costTop < (window.innerHeight - (i + 1) * 100 + 100)) {
      ele.style.left = '80rem'
    } else {
      ele.style.left = ele.getBoundingClientRect().width + 80 * screenRatio + 'px'
    }
  });
}

onMounted(async () => {
  window.addEventListener('scroll', scrollEvent, false)
  window.scrollTo(0, 0)

  const home_banner_mp4: any = await asynchronousRetrieval('webimg/video/home-banner.mp4');
  const studio_mp4: any = await asynchronousRetrieval('webimg/video/studio.mp4');
  const entertainment_mp4: any = await asynchronousRetrieval('webimg/gif/entertainment.gif');
  const industry_mp4: any = await asynchronousRetrieval('webimg/gif/industry.gif');
  const education_mp4: any = await asynchronousRetrieval('webimg/gif/education.gif');
  const particles_moment_mp4: any = await asynchronousRetrieval('webimg/images/home/particles-moment.mp4');
  const wechat_gif: any = await asynchronousRetrieval('webimg/gif/wechat.gif');
  const VR_gif: any = await asynchronousRetrieval('webimg/gif/VR.gif');
  const AR_gif: any = await asynchronousRetrieval('webimg/gif/AR.gif');
  const web_gif: any = await asynchronousRetrieval('webimg/gif/web.gif');
  const core_advantages_bg: any = await asynchronousRetrieval('webimg/images/home/core-advantages-bg.png');
  const ycaozuo_gif: any = await asynchronousRetrieval('webimg/ycaozuo.gif');
  const partner_bg: any = await asynchronousRetrieval('webimg/images/home/partner-bg.png');
  const partner3: any = await asynchronousRetrieval('webimg/images/home/partner3.png');
  const bg_mask: any = await asynchronousRetrieval('webimg/images/home/bg-mask.png');
  loadUrl.value = { home_banner_mp4, studio_mp4, entertainment_mp4, particles_moment_mp4, industry_mp4, education_mp4, wechat_gif, VR_gif, AR_gif, web_gif, core_advantages_bg, ycaozuo_gif, partner_bg, partner3, bg_mask }

  metaversePlatformList.value[0].url = entertainment_mp4;
  metaversePlatformList.value[1].url = industry_mp4;
  metaversePlatformList.value[2].url = education_mp4;
  projectTypeList.value[0].imgs[0].url = wechat_gif;
  projectTypeList.value[1].imgs[0].url = VR_gif;
  projectTypeList.value[2].imgs[0].url = AR_gif;
  projectTypeList.value[3].imgs[0].url = web_gif;
})

onUnmounted(() => {
  window.removeEventListener('scroll', scrollEvent, false)
  clearInterval(timer)
  store.state.zoomScreened = false
  window.scrollTo(0, 0)
})

const openTimer = () => {
  clearInterval(timer)
  timer = setInterval(() => {
    viewTime.value += 1;
    if (viewTime.value > fusionVideo.value[activeFusionIndex.value]) {
      if (store.state.zoomScreened) {
        activeFusionIndex.value += 1;
        if (activeFusionIndex.value > 2) {
          activeFusionIndex.value = 0
        }
        console.log(activeFusionIndex.value, 2222)
      }
      viewTime.value = 1;
    }
  }, 1000)
}

watch(viewTime, (newState) => {
  const metaverseLine: any = document.querySelectorAll('.metaverse-line>div');
  metaverseLine.forEach((ele: any) => {
    ele.style.width = 0
  })
  metaverseLine[activeFusionIndex.value].style.width = 300 / fusionVideo.value[activeFusionIndex.value] * newState + 'rem'
})

watch(activeFusionIndex, async(newState) => {
  const windowVideo: any = document.querySelectorAll('.fusion-window>img');
  windowVideo[newState].currentTime = 0;
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("video", {
        src: loadUrl.value.home_banner_mp4,
        autoplay: "",
        loop: "",
        muted: "",
        playsinline: "",
        "webkit-playsinline": ""
      }, null, 8, _hoisted_2),
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"video-text\" data-v-53e775ee><div class=\"logo-text\" data-v-53e775ee></div><div class=\"link-room\" data-v-53e775ee>打开「眼界」链接全新数字空间</div><div class=\"text-tips\" data-v-53e775ee>提供大空间数实融合新方案，通过灵活的采集方案、专业的空间定位及完善的后台工具，为众多行业进行AR数字化赋能。</div><a class=\"experience-now\" href=\"https://mixedspace.njyjxr.com\" data-v-53e775ee><span data-v-53e775ee>立即体验</span><div class=\"experience-btn\" data-v-53e775ee></div></a></div><div class=\"video-mask\" data-v-53e775ee></div>", 2))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", {
        src: loadUrl.value.core_advantages_bg
      }, null, 8, _hoisted_4),
      _createElementVNode("div", null, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "core-title" }, "混空Studio核心优势", -1)),
        _cache[8] || (_cache[8] = _createElementVNode("div", null, "构建 “内容创作及分发 + 智能体” 生态,定义元宇宙创作新范式", -1)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("video", {
              src: loadUrl.value.studio_mp4,
              autoplay: "",
              loop: "",
              muted: "",
              poster: _imports_0,
              playsinline: "",
              "webkit-playsinline": ""
            }, null, 8, _hoisted_7)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "title" }, "成本低", -1)),
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(costList, (item, index) => {
                  return _createElementVNode("div", { key: index }, [
                    _createElementVNode("div", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (e, i) => {
                        return (_openBlock(), _createElementBlock("div", { key: i }, _toDisplayString(e), 1))
                      }), 128))
                    ])
                  ])
                }), 64))
              ])
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "high-precision" }, [
              _createElementVNode("div", { class: "title" }, "高精度"),
              _createElementVNode("div", { class: "precision-text" }, [
                _createElementVNode("div", null, "自研高精度空间定位算法"),
                _createElementVNode("div", null, "厘米级视觉定位"),
                _createElementVNode("div", null, "空间导航精准"),
                _createElementVNode("div", null, "支持大空间定位")
              ]),
              _createElementVNode("div", { class: "high-precision-image" })
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "title" }, "易操作", -1)),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("img", {
                src: loadUrl.value.ycaozuo_gif
              }, null, 8, _hoisted_13)
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("div", null, [
              _createElementVNode("div", null, "自研AI+AR元宇宙内容创作与分发平台"),
              _createElementVNode("div", null, "3D场景地图，可视化交互智能创作"),
              _createElementVNode("div", null, "所“建”即所得")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_14, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "title" }, "部署快", -1)),
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(arrangeList, (item) => {
                return _createElementVNode("div", { key: item }, [
                  _createElementVNode("img", { src: item }, null, 8, _hoisted_16)
                ])
              }), 64))
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("div", null, [
              _createElementVNode("div", null, "仅需四步，快速部署"),
              _createElementVNode("div", null, "支持快速导入模型、音效和互动元素"),
              _createElementVNode("div", null, "无需安装，在网页端即可完成空间创作")
            ], -1))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      (!_unref(store).state.zoomScreened)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("video", {
              src: loadUrl.value.entertainment_mp4,
              autoplay: "",
              loop: "",
              muted: "",
              playsinline: "",
              "webkit-playsinline": ""
            }, null, 8, _hoisted_19)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "fusion-content",
        style: _normalizeStyle({ opacity: _unref(store).state.zoomScreened ? 1 : 0 })
      }, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "fusion-title" }, "数实融合 虚实互生", -1)),
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "fusion-tips" }, "共同推动产业创新融合发展", -1)),
        _createElementVNode("div", _hoisted_20, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(metaversePlatformList.value, (item, index) => {
            return _withDirectives((_openBlock(), _createElementBlock("img", {
              src: item.url,
              key: index,
              style: _normalizeStyle({ opacity: activeFusionIndex.value == index ? 1 : 0 })
            }, null, 12, _hoisted_21)), [
              [_vShow, item.url]
            ])
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_22, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(metaversePlatformList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.type,
              class: _normalizeClass(activeFusionIndex.value == index ? 'active' : ''),
              onClick: ($event: any) => {activeFusionIndex.value = index; viewTime.value = 1}
            }, [
              _createElementVNode("div", _hoisted_24, _toDisplayString(item.title), 1),
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "metaverse-line" }, [
                _createElementVNode("div")
              ], -1)),
              _createElementVNode("div", _hoisted_25, _toDisplayString(item.content), 1)
            ], 10, _hoisted_23))
          }), 128))
        ])
      ], 4)
    ]),
    _createElementVNode("div", _hoisted_26, [
      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "show-project-title" }, "跨设备部署全场景展示每个项目", -1)),
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "show-project-tips" }, "文娱景区、剧场演绎、博物馆/文化馆、IP展览、商场、企业展厅", -1)),
      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "show-project-tips" }, "大型活动、品牌营销互动、广告策划、空间设计、教育培训、工业培训等。", -1)),
      _createVNode(BannerView, { "banner-data": projectTypeList.value }, null, 8, ["banner-data"])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("img", {
        src: loadUrl.value.partner_bg
      }, null, 8, _hoisted_28),
      _createElementVNode("div", null, [
        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "serve-customers" }, "服务客户2000+", -1)),
        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "serve-tips" }, "助力AR创新更多可能", -1)),
        _createElementVNode("div", {
          class: "serve-btn",
          onClick: handleEvent
        }, "立即咨询")
      ]),
      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "partner-list partner1" }, null, -1)),
      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "partner-list partner2" }, null, -1)),
      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "partner-list partner3" }, null, -1)),
      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "partner-list partner4" }, null, -1)),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("img", {
          src: loadUrl.value.bg_mask
        }, null, 8, _hoisted_30)
      ])
    ]),
    (_unref(store).state.contactUsTop)
      ? (_openBlock(), _createBlock(ContactUs, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(GlobalCustomerService)
  ]))
}
}

})